import { render } from "./FinanzasPaciente.vue?vue&type=template&id=1a5bb5c6&scoped=true"
import script from "./FinanzasPaciente.vue?vue&type=script&lang=js"
export * from "./FinanzasPaciente.vue?vue&type=script&lang=js"

import "./FinanzasPaciente.vue?vue&type=style&index=0&id=1a5bb5c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5bb5c6"]])

export default __exports__